import React from 'react';

export const getLastItemSort = (
  isGoingNext: boolean | undefined,
  lastItemSorts: object[] | undefined
): object | null => {
  if (isGoingNext === undefined || !lastItemSorts || !lastItemSorts?.length) {
    return null;
  }
  if (isGoingNext) {
    return lastItemSorts[lastItemSorts.length - 1];
  }

  if (lastItemSorts.length > 2) {
    return lastItemSorts[lastItemSorts.length - 3];
  }

  return null;
};

export const updateLastItemSorts = (
  isGoingNext: boolean | undefined,
  setLastItemSorts: React.Dispatch<React.SetStateAction<object[]>>,
  newLastItemSort: object
): void => {
  if (isGoingNext === undefined) {
    setLastItemSorts([newLastItemSort]);
  } else if (isGoingNext === true) {
    setLastItemSorts((prev) => [...prev, newLastItemSort]);
  } else if (isGoingNext === false) {
    setLastItemSorts((prev) => prev.slice(0, -1));
  }
};
